'use client';

import { Heading } from '@preventx/oxygen';
import { useEffect, useState } from 'react';

// Types
import { ProductVariantOption } from '@/types/products/productVariants';

// Contexts
import { useProductDetailsContext } from '@/context/ProductDetailsProvider';

type PriceHeadingProps = {
  basePrice: string;
  productOptions: ProductVariantOption[];
};

export const PriceHeading = ({
  basePrice,
  productOptions,
}: PriceHeadingProps) => {
  const { product } = useProductDetailsContext();

  const [price, setPrice] = useState<string>(basePrice);

  useEffect(() => {
    if (!product.radioValue) {
      setPrice(basePrice);

      return;
    }

    const option = productOptions.find(({ id }) => id === product.radioValue);

    setPrice(option?.price.toString() ?? basePrice);
  }, [product]);

  return (
    <Heading component="h2" className="mt-2">
      {price}
    </Heading>
  );
};
